import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { IReadVerbPayload } from "../declarations/IReadVerbPayload";
import { useGetSalesOrderLinesD365 } from "../hooks/SalesOrderLine/D365/useGetSalesOrderLinesD365";

interface ISalesOrderLinesContainerProps {
    dataAreaID: string | undefined;
    orderNumber: string | undefined;
}
export default function SalesOrderLinesContainer(
    props: Readonly<ISalesOrderLinesContainerProps>,
) {
    const SalesOrderHeaderPayload: IReadVerbPayload = {
        keys: {
            salesOrderNumber: props.orderNumber ?? "",
            dataAreaId: props.dataAreaID ?? "",
        },
    };

    const { data: salesOrderLinesD365, isLoading } = useGetSalesOrderLinesD365(
        SalesOrderHeaderPayload,
    );

    return (
        <Table className="foTable">
            <TableHead>
                <TableRow>
                    <TableCell>Line ID</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Product</TableCell>
                    <TableCell>Item (Released Product)</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {isLoading && (
                    <TableRow>
                        <TableCell colSpan={3}>Loading</TableCell>
                    </TableRow>
                )}
                {!isLoading &&
                    salesOrderLinesD365?.map((line) => (
                        <TableRow key={line.inventoryLotId}>
                            <TableCell>{line.lineNumber}</TableCell>
                            <TableCell>
                                {line.lineDescription} x{" "}
                                {line.salesPriceQuantity}
                                {line.salesUnitSymbol}
                            </TableCell>
                            <TableCell>{line.itemNumber}</TableCell>
                            <TableCell>{line.itemNumber}</TableCell>
                        </TableRow>
                    ))}
            </TableBody>
        </Table>
    );
}
